import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.string.ends-with";
import { __decorate, __extends } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';

var SimpleKeyboard =
/** @class */
function (_super) {
  __extends(SimpleKeyboard, _super);

  function SimpleKeyboard() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.keyboard = null;
    _this.valueToSet = '';
    return _this;
  }

  SimpleKeyboard.prototype.onKeyPress = function (button) {
    //If you want to handle the shift and caps lock buttons
    if (button === '{shift}') {
      this.handleShift();
    }

    if (button === '{lock}') {
      this.handleCapsLock();
    }
  };

  SimpleKeyboard.prototype.handleShift = function () {
    var currentLayout = this.keyboard.options.layoutName;
    var shiftToggle = currentLayout === 'default' ? 'shift' : 'default';
    this.keyboard.setOptions({
      layoutName: shiftToggle
    });
  };

  SimpleKeyboard.prototype.handleCapsLock = function () {
    var currentLayout = this.keyboard.options.layoutName;
    var capsToggle = currentLayout === 'default' ? 'caps' : 'default';
    this.keyboard.setOptions({
      layoutName: capsToggle
    });
  };

  SimpleKeyboard.prototype.onChange = function (value) {
    this.valueToSet = value;

    if (this.type === 'number') {
      if (this.validateInputNumber(this.valueToSet)) {
        this.keyboard.setInput(this.valueToSet.slice(0, -1));
        this.valueToSet = value.slice(0, -1);
      } else {
        if (this.valueToSet.endsWith('.')) {
          var numberInt = this.valueToSet.slice(0, -1);
          this.$emit('onChange', numberInt);
        } else if (this.valueToSet.endsWith('-')) {
          this.valueToSet = this.valueToSet.slice(0, -1);

          if (this.valueToSet.length === 0) {
            this.valueToSet = '-';
          } else if (Number(this.valueToSet) <= 0) {
            this.valueToSet = this.valueToSet.slice(1);
          } else if (Number(this.valueToSet) > 0) {
            this.valueToSet = '-' + this.valueToSet;
          }

          this.$emit('onChange', this.valueToSet);
        } else {
          this.$emit('onChange', this.valueToSet);
        }
      }
    } else {
      this.$emit('onChange', this.valueToSet);
    }
  };

  SimpleKeyboard.prototype.validateInputNumber = function (value) {
    var pointCount = 0;

    for (var i = 0; i < value.length; i++) {
      if (value[i] === '.') {
        pointCount++;

        if (pointCount > 1) {
          return true;
        }
      }
    }

    return false;
  };

  SimpleKeyboard.prototype.ifInputChange = function (newValue) {
    this.keyboard.setInput(newValue);
  };

  SimpleKeyboard.prototype.mounted = function () {
    var numberLayout = this.getNumberLayout();
    var stringLayout = {
      default: ['` 1 2 3 4 5 6 7 8 9 0 - = {bksp}', '{tab} q w e r t y u i o p [ ] \\', '{lock} a s d f g h j k l ñ ; \' {enter}', '{shift} z x c v b n m , . / {shift}', '.com @ {space}'],
      shift: ['~ ! @ # $ % ^ &amp; * ( ) _ + {bksp}', '{tab} Q W E R T Y U I O P { } |', '{lock} A S D F G H J K L Ñ : " {enter}', '{shift} Z X C V B N M &lt; &gt; ? {shift}', '.com @ {space}'],
      caps: ['Á á É é Í í Ó ó Ú ú {bksp}', '{tab} Q W E R T Y U I O P { } |', '{lock} A S D F G H J K L Ñ : " {enter}', '{shift} Z X C V B N M &lt; &gt; ? {shift}', '.com @ {space}']
    };
    var layout = this.type === 'number' ? numberLayout : stringLayout;
    this.keyboard = new Keyboard('simple-keyboard', {
      layout: layout,
      onKeyPress: this.onKeyPress,
      onChange: this.onChange
    });
    this.valueToSet = this.value;

    if (this.valueToSet === null) {
      this.valueToSet = '';
    } else {
      this.valueToSet = String(this.value);
    }

    this.keyboard.setInput(this.valueToSet);
  };

  SimpleKeyboard.prototype.getNumberLayout = function () {
    var defaultLayout = ['1 2 3', '4 5 6', '7 8 9', '0 - {bksp} .'];
    return {
      default: defaultLayout
    };
  };

  __decorate([Prop()], SimpleKeyboard.prototype, "value", void 0);

  __decorate([Prop({
    default: 'text'
  })], SimpleKeyboard.prototype, "type", void 0);

  __decorate([Prop()], SimpleKeyboard.prototype, "numericSteps", void 0);

  __decorate([Watch('value')], SimpleKeyboard.prototype, "ifInputChange", null);

  SimpleKeyboard = __decorate([Component({
    components: {}
  })], SimpleKeyboard);
  return SimpleKeyboard;
}(Vue);

export default SimpleKeyboard;